import {AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {ConsumerAuthenticationInformationEnrollment} from '@app/model/cyber-source/payer-auth-enrollment-response';
import {first} from 'rxjs/operators';
import {LaunchDialogService} from '@spartacus/storefront';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {isPlatformBrowser} from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'dcp-cyber-source-threeds-dialog',
  templateUrl: './cyber-source-threeds-dialog.component.html',
  styleUrl: './cyber-source-threeds-dialog.component.scss'
})
export class CyberSourceThreedsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('stepUpForm') stepUpForm?: ElementRef;
  authEnrollmentData: ConsumerAuthenticationInformationEnrollment;
  body: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    public launchDialogService: LaunchDialogService,
  ) {
  }

  ngOnInit(): void {
    this.launchDialogService.data$.pipe(first(), untilDestroyed(this)).subscribe((data) => {
      this.authEnrollmentData = data.consumerAuthenticationInformation;
      this.body = JSON.stringify({cartId: data.cartId});
    });
  }

  ngAfterViewInit(): void {
    this.stepUpForm.nativeElement.submit();
  }

  sendCancelMessage(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.postMessage({type: '3DSComplete', cancelled: true});
    }
  }
}
